module.exports = __webpack_public_path__ + "images/application/promo/email-auth-video-thumb-a2f7d8e2.png";